import React from "react";
import { useTranslation } from "../../hooks/useTranslation";
import PageShell, { PageHero } from "../../v2/pages/PageShell";

const LegalNotice: React.FC = () => {
  const { currentLanguage } = useTranslation();

  const fr = (
    <>
      <PageShell
        seo={{
          title: "Mentions légales | Lave Tes Baskets",
          description: "Éditeur, hébergeur et informations légales du site Lave Tes Baskets.",
          canonicalPath: `/${currentLanguage}/legal`,
        }}
      >
        <PageHero
          crumbs={[{ label: "Accueil", to: `/${currentLanguage}` }, { label: "Mentions légales" }]}
          index="§"
          eyebrow={"Légal"}
          title={"Mentions légales"}
        />
        <section className="bg-bone py-14 text-ink sm:py-20">
          <div className="v2-prose mx-auto max-w-3xl px-4 sm:px-6">
              <p className="mb-4">
                Conformément à l'article 6 de la Loi n°2004-575 du 21 juin 2004
                pour la confiance dans l'économie numérique.
              </p>

              <h3 className="text-xl sm:text-2xl font-semibold mt-8 mb-3">
                Éditeur du site
              </h3>
              <p className="mb-4">
                LTB — Société par actions simplifiée (SAS)
                <br />
                Capital social : 1 000,00 €
                <br />
                Siège social : 173 rue de Courcelles, 75017 Paris, France
                <br />
                RCS Paris : 108 540 253
                <br />
                SIREN : 108 540 253
                <br />
                N° de gestion : 2026B40041
                <br />
                Email : contact@lavetesbaskets.fr
                
              </p>

              <h3 className="text-xl sm:text-2xl font-semibold mt-8 mb-3">
                Hébergeur
              </h3>
              <p className="mb-4">
                Hetzner Online GmbH
                <br />
                Industriestr. 25, 91710 Gunzenhausen, Allemagne
                <br />
                Datacenter : Nuremberg (Allemagne)
                <br />
                Téléphone : +49 (0)9831 505-0
                <br />
                Site : www.hetzner.com
              </p>

              {/* Section Propriété intellectuelle retirée pour éviter la répétition avec les CGU */}

              <h3 className="text-xl sm:text-2xl font-semibold mt-8 mb-3">
                Responsabilité
              </h3>
              <p className="mb-4">
                LTB met tout en œuvre pour assurer l'exactitude des
                informations, sans garantie. Le site peut contenir des liens
                externes.
              </p>

              <h3 className="text-xl sm:text-2xl font-semibold mt-8 mb-3">
                Contact
              </h3>
              <p className="mb-4">
                Pour toute demande concernant ces mentions :
                legal@lavetesbaskets.com
              </p>

              {/* Données personnelles à la fin */}
              <h3 className="text-xl sm:text-2xl font-semibold mt-8 mb-3">
                Données personnelles
              </h3>
              <p className="mb-4">
                Voir notre {""}
                <a
                  href={`/${currentLanguage}/privacy`}
                  className="text-accent-teal underline"
                >
                  Politique de Confidentialité
                </a>
                .
              </p>
            </div>
        </section>
      </PageShell>
    </>
  );

  const en = (
    <>
      <PageShell
        seo={{
          title: "Legal notice | Lave Tes Baskets",
          description: "Publisher, hosting provider and legal information for Lave Tes Baskets.",
          canonicalPath: `/${currentLanguage}/legal`,
        }}
      >
        <PageHero
          crumbs={[{ label: "Home", to: `/${currentLanguage}` }, { label: "Legal notice" }]}
          index="§"
          eyebrow={"Legal"}
          title={"Legal notice"}
        />
        <section className="bg-bone py-14 text-ink sm:py-20">
          <div className="v2-prose mx-auto max-w-3xl px-4 sm:px-6">
              <p className="mb-4">
                Publisher and legal information in accordance with French law,
                including the French Law for Confidence in the Digital Economy
                (LCEN, Law No. 2004-575 of 21 June 2004).
              </p>

              <h3 className="text-xl sm:text-2xl font-semibold mt-8 mb-3">
                Publisher
              </h3>
              <p className="mb-4">
                LTB — Société par actions simplifiée (SAS, French simplified
                joint-stock company)
                <br />
                Share capital: €1,000.00
                <br />
                Registered office: 173 rue de Courcelles, 75017 Paris, France
                <br />
                Paris Trade & Companies Register (RCS): 108 540 253
                <br />
                SIREN: 108 540 253
                <br />
                Intra-community VAT: FR16 108540253
                <br />
                Email: contact@lavetesbaskets.fr
                <br />
                Legal representative (President) and publication director: Diane
                Cynthia Nkweya Mouyon
              </p>

              <h3 className="text-xl sm:text-2xl font-semibold mt-8 mb-3">
                Hosting provider
              </h3>
              <p className="mb-4">
                Hetzner Online GmbH
                <br />
                Industriestr. 25, 91710 Gunzenhausen, Germany
                <br />
                Data center: Nuremberg (Germany)
                <br />
                Phone: +49 (0)9831 505-0
                <br />
                Website: www.hetzner.com
              </p>

              {/* Intellectual property section removed to avoid repetition with Terms */}

              <h3 className="text-xl sm:text-2xl font-semibold mt-8 mb-3">
                Liability
              </h3>
              <p className="mb-4">
                While LTB strives for accurate information, no warranty is
                given. The site may include external links for which LTB is not
                responsible.
              </p>

              <h3 className="text-xl sm:text-2xl font-semibold mt-8 mb-3">
                Contact
              </h3>
              <p className="mb-4">
                For any request related to this legal notice:
                legal@lavetesbaskets.com
              </p>

              {/* Personal data at the end */}
              <h3 className="text-xl sm:text-2xl font-semibold mt-8 mb-3">
                Personal data
              </h3>
              <p className="mb-4">
                See our {""}
                <a
                  href={`/${currentLanguage}/privacy`}
                  className="text-accent-teal underline"
                >
                  Privacy Policy
                </a>
                .
              </p>
            </div>
        </section>
      </PageShell>
    </>
  );

  return currentLanguage === "fr" ? fr : en;
};

export default LegalNotice;
